import { useState } from 'react';
import { message } from 'antd';
import useAsyncEffect from 'src/hooks/useAsyncEffect';
import { CriteriaListItem } from '../types/AlertConfiguration';
import { getAlertCriteria } from '../../services/alertConfiguration.service';

type AlertCriteriaGroupsState = {
  loading: boolean;
  criteriaGroups: CriteriaListItem[][] | null;
};

export const useAlertCriteriaGroups = (alertId?: number): AlertCriteriaGroupsState => {
  const [loading, setLoading] = useState<boolean>(false);
  const [criteriaGroups, setCriteriaGroups] = useState<CriteriaListItem[][] | null>(null);

  const fetchAlertCriteria = async (alertId: number) => {
    setLoading(true);
    try {
      const criteriaMap = new Map<number, CriteriaListItem[]>();
      const alertCriteriaList = await getAlertCriteria(alertId);
      alertCriteriaList.forEach((item) => {
        const group = criteriaMap.get(item.alertGroupId) ?? [];
        criteriaMap.set(item.alertGroupId, group.concat(item));
      });
      setCriteriaGroups([...criteriaMap.values()]);
    } catch (e) {
      message.error('There was an error while loading Alert Criteria list.');
      console.error(e);
    }
    setLoading(false);
  };

  useAsyncEffect(async () => {
    if (alertId) {
      fetchAlertCriteria(alertId);
    }
  }, [alertId]);

  return { loading, criteriaGroups };
};
